import Phaser from 'phaser';

// import {
//   initializeDecelerationPath,
//   currentDecelerationPathPosition,
//   isDecelerationAnimationFinished,
// } from  './DecelerationAnimator';

import {
  initializeNode,
  drawNode,
  isCenter,
  selectNode,
  nodeBody,
  nodeExtendedBody,

  EXPANDED_NODE_DIAMETER,
  CENTER_NODE_DIAMETER,
  CENTER_NODE_RADIUS,
  EXPANDED_NODE_RADIUS,
  ICON_NODE_RADIUS,
  CENTER_NAME,
} from './Node';

// import ExampleIwl from './ExampleIwl';

const OVERLAY_TEXT_WIDTH = 232;
const OVERLAY_TEXT_PADDING = 16;
const OVERLAY_ARROW_WIDTH = 10;
const OVERLAY_ARROW_HALF_HEIGHT = 10;
const EXPANDED_NODE_MAIN_RADIUS = EXPANDED_NODE_RADIUS * 0.7;

let phaserInstance;
let nodeBaseURL;
let nodeImageMap;

let iWheelExploration;
let nodeSprites;
let nodeEditButtonSprites;
let iconNodeSprites;
let nodeLines;
let selectedNodeName;
let rolloverNodeEditButton;

let overlayText;
let overlaySprite;
let overlayBackground;
let overlayNode;
let canvas;
let explicitlyShowOverlays = false;
let blockRolloverNodeOneTime = false;

function clickNode () {
  selectThisNode(this.getData('nodeData'));
}

function selectThisNode(selectedNode) {
  explicitlyShowOverlays = selectedNodeName === selectedNode.name;
  selectedNodeName = selectedNode.name;
  iWheelExploration = selectNode({ selectedNode, iWheelExploration });

  // touch devices may not have a mouse, so show the edit button if the user
  // taps an already selected node
  if (explicitlyShowOverlays) {
    blockRolloverNodeOneTime = selectedNodeName;
    showEditButton(selectedNode);
    showOverlay(selectedNode);
  }

  // console.log(selectedNodeName);
}

function clickEditButton() {
  const nodeData = this.getData('nodeData');
  window.editNode(nodeData.id);

  // console.log(`edit ${nodeData.name}`);
}

function rolloverEditButton() {
  const nodeData = this.getData('nodeData');
  showEditButton(nodeData);
  showOverlay(nodeData);

  // console.log(nodeData.name);
}

function rolloverNode () {
  const nodeData = this.getData('nodeData');

  if (blockRolloverNodeOneTime === nodeData.name) {
    blockRolloverNodeOneTime = null;
    return;
  }

  blockRolloverNodeOneTime = null;
  explicitlyShowOverlays = false;

  showEditButton(nodeData);
  showOverlay(nodeData);

  // console.log(nodeData.name);
}

function rolloffNode () {
  hideEditButton();
  hideOverlay();

  // const nodeData = this.getData('nodeData');
  // console.log(`off ${nodeData.name}`);
}

function hideEditButton() {
  if (explicitlyShowOverlays) return;
  if (rolloverNodeEditButton) rolloverNodeEditButton.setVisible(false);
}

function showOverlay(nodeData) {
  overlayNode = nodeData;
  overlayText.setText(nodeExtendedBody(nodeData));
  overlaySprite
    .setVisible(true)
    .setPosition(-1000, -1000);
}

function hideOverlay() {
  if (explicitlyShowOverlays) return;
  overlayNode = null;
  overlaySprite
    .setVisible(false)
    .setPosition(-1000, -1000);
}

function showEditButton (nodeData) {
  if (rolloverNodeEditButton) rolloverNodeEditButton.setVisible(false);
  rolloverNodeEditButton = nodeEditButtonSprites[nodeData.id];
  if (rolloverNodeEditButton) rolloverNodeEditButton.setVisible(true);
}

function drawOverlayBackground ({ arrowDirection, arrowY }) {
  let triangleLeft;
  let triangleRight;
  const cornerRadii = { tl: OVERLAY_TEXT_PADDING, tr: OVERLAY_TEXT_PADDING, bl: OVERLAY_TEXT_PADDING, br: OVERLAY_TEXT_PADDING };
  const height = overlayText.height;
  overlayBackground.clear();

  overlayBackground.fillStyle(0xf1f8ff, 1);
  overlayBackground.lineStyle(1, 0xc8e1ff, 1);

  if (arrowY < -height / 2 + OVERLAY_TEXT_PADDING + OVERLAY_ARROW_HALF_HEIGHT) {
    cornerRadii.tr = 0;
  } else if (arrowY > height / 2 - OVERLAY_TEXT_PADDING - OVERLAY_ARROW_HALF_HEIGHT) {
    cornerRadii.br = 0;
  }

  overlayBackground.fillRoundedRect(0, -height / 2, OVERLAY_TEXT_WIDTH, height, cornerRadii);
  overlayBackground.strokeRoundedRect(0, -height / 2, OVERLAY_TEXT_WIDTH, height, cornerRadii);

  switch (arrowDirection) {
  case 'left':
    triangleLeft = OVERLAY_TEXT_WIDTH - 1;
    overlayBackground.fillTriangle(triangleLeft, arrowY - OVERLAY_ARROW_HALF_HEIGHT, triangleLeft + OVERLAY_ARROW_WIDTH, arrowY, triangleLeft, arrowY + OVERLAY_ARROW_HALF_HEIGHT);
    overlayBackground.strokePoints([
      { x: triangleLeft, y: arrowY - OVERLAY_ARROW_HALF_HEIGHT },
      { x: triangleLeft + OVERLAY_ARROW_WIDTH, y: arrowY },
      { x: triangleLeft, y: arrowY + OVERLAY_ARROW_HALF_HEIGHT },
    ]);
    break;

  case 'right':
    triangleRight = 1;
    overlayBackground.fillTriangle(triangleRight, arrowY - OVERLAY_ARROW_HALF_HEIGHT, triangleRight - OVERLAY_ARROW_WIDTH, arrowY, triangleRight, arrowY + OVERLAY_ARROW_HALF_HEIGHT);
    overlayBackground.strokePoints([
      { x: triangleRight, y: arrowY - OVERLAY_ARROW_HALF_HEIGHT },
      { x: triangleRight - OVERLAY_ARROW_WIDTH, y: arrowY },
      { x: triangleRight, y: arrowY + OVERLAY_ARROW_HALF_HEIGHT },
    ]);
    break;
  }
}

const hitTest = (x, y, radius) => Math.sqrt(x * x + y * y) <= radius;
const rectangleHitTest = (x, y, rectWidth, rectHeight) =>
  -rectWidth / 2 <= x && x <= rectWidth / 2 &&
  -rectHeight / 2 <= y && y <= rectHeight / 2;
const centerHitTest = (_, x, y, sprite) => sprite.visible && hitTest(x, y, CENTER_NODE_RADIUS * 0.7);
const nodeHitTest = (_, x, y, sprite) => sprite.visible && hitTest(x, y, EXPANDED_NODE_MAIN_RADIUS);
const editButtonHitTest = ({ x, y, sprite, buttonWidth, buttonHeight }) =>
  sprite.visible && rectangleHitTest(x, y, buttonWidth, buttonHeight);

// const iconNodeHitTest = (_, x, y, sprite) => sprite.visible && hitTest(x, y, ICON_NODE_RADIUS * sprite.scale);

const config = {
  type: Phaser.AUTO,
  scale: {
    parent: 'visualizer',
    mode: Phaser.Scale.RESIZE,
    width: '100%',
    height: '100%',
  },
  scene: {
    preload: preload,
    create: create,
    update: update,
  }
};

export default function () {
  window.iWheelVisualizer = display;
}

function display ({ nodeData, nodeName=null, visualizerNodeBaseURL, visualizerNodeImageMap }) {
  nodeBaseURL = visualizerNodeBaseURL;
  nodeImageMap = visualizerNodeImageMap;
  iWheelExploration = initializeNode({ sourceData: nodeData, startingCenterX: -1000 });

  nodeSprites = {};
  nodeEditButtonSprites = {};
  iconNodeSprites = {};
  nodeLines = {};
  selectedNodeName = nodeName ? nodeName : CENTER_NAME;
  rolloverNodeEditButton = null;

  overlayText = null;
  overlaySprite = null;
  overlayBackground = null;
  overlayNode = null;

  if (phaserInstance) {
    phaserInstance.events.on('destroy', () =>
      setTimeout(() => phaserInstance = new Phaser.Game(config))
    );

    phaserInstance.destroy(true);

  } else {
    phaserInstance = new Phaser.Game(config);
  }
}

function preload() {
  this.load.setBaseURL(nodeBaseURL);
  let imageNames = [];

  drawNode({
    nodeData: iWheelExploration,
    parentPosition: { x: 300, y: 300 },
    initializing: true,
    drawFunction: ({ nodeData, nodeImageName, iconNodeImageName }) => {
      imageNames.push(nodeImageName);
      if (!isCenter(nodeData)) imageNames.push(iconNodeImageName);
    },
  });

  imageNames.forEach(imageName => this.load.image(imageName, nodeImageMap[imageName]));
}

function create() {
  const textStyle = {
    align: 'center',
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, "Helvetica Neue", sans-serif',
    fontSize: '16px',
    // resolution: 2,
    wordWrap: {
      useAdvancedWrap: true,
      width: EXPANDED_NODE_DIAMETER * 0.6,
    }
  };

  const overlayTextStyle = {
    align: 'left',
    // backgroundColor: '#ffffff',
    fill: '#222222',
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, "Helvetica Neue", sans-serif',
    fontSize: '16px',
    padding: { x: OVERLAY_TEXT_PADDING, y: OVERLAY_TEXT_PADDING },
    // resolution: 2,
    wordWrap: {
      useAdvancedWrap: false,
      width: OVERLAY_TEXT_WIDTH - OVERLAY_TEXT_PADDING * 2,
    }
  };

  const editButtonTextStyle = {
    align: 'center',
    fill: '#222222',
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, "Helvetica Neue", sans-serif',
    fontSize: '16px',
    padding: { x: 16, y: 8 },
    // resolution: 2,
  };

  this.cameras.main.backgroundColor = Phaser.Display.Color.HexStringToColor('#619bf4');

  overlayBackground = this.add.graphics();
  overlayText = this.add.text(0, 0, '', overlayTextStyle);
  overlayText.setOrigin(0, 0.5);

  overlaySprite = this.add.container(0, 0)
    .add(overlayBackground)
    .add(overlayText)
    .setPosition(-1000, -1000)
    .setVisible(false)
    .setDepth(2);


  canvas = this.sys.game.canvas;


  drawNode({
    nodeData: iWheelExploration,
    selectedNodeName,
    screenWidth: canvas.width,
    screenHalfHeight: canvas.height / 2,
    drawFunction: ({ nodeData, lineSegments }) => {
      nodeLines[nodeData.id] = [];
      lineSegments.map(lineSegment =>
        nodeLines[nodeData.id].push(
          this.add.line(0, 0, lineSegment[0].x, lineSegment[0].y, lineSegment[1].x, lineSegment[1].y, nodeData.flagged ? 0xffff00 : 0x000000, nodeData.flagged ? 1 : 0.6)
            .setOrigin(0, 0)
        )
      );
    }
  });

  drawNode({
    nodeData: iWheelExploration,
    initializing: true,
    selectedNodeName,
    screenWidth: canvas.width,
    screenHalfHeight: canvas.height / 2,
    drawFunction: ({ nodeData, nodeImageName, iconNodeImageName, textColor, isIcon, position, scale }) => {
      const nodeImage = this.add.image(0, 0, nodeImageName);
      const center = isCenter(nodeData);
      let fontSize;

      if (!center) {
        fontSize = '16px';
      } else if (nodeData.text.length > 70) {
        fontSize = '36px';
      } else {
        fontSize = '48px';
      }

      const customTextStyle = {
        ...textStyle,
        fill: textColor,
        fontSize: fontSize,
        wordWrap: {
          useAdvancedWrap: true,
          width: center ? CENTER_NODE_DIAMETER * 0.6 : EXPANDED_NODE_DIAMETER * 0.6,
        }
      };

      const nodeText = this.add.text(0, 0, nodeBody(nodeData), customTextStyle);
      nodeText.setOrigin(0.5, 0.5);


      let editButtonSprite;

      if (nodeData.editable) {
        const editButtonBackground = this.add.graphics();
        const editButtonText = this.add.text(0, 0, 'EDIT', editButtonTextStyle);
        editButtonText.setOrigin(0.5, 0.5);
        const buttonWidth = editButtonText.width;
        const buttonHeight = editButtonText.height;

        editButtonBackground.fillStyle(0xffffff, 1);
        editButtonBackground.lineStyle(1, 0x222222, 1);
        editButtonBackground.fillRoundedRect(-buttonWidth / 2, -buttonHeight / 2, buttonWidth, buttonHeight, 3);
        editButtonBackground.strokeRoundedRect(-buttonWidth / 2, -buttonHeight / 2, buttonWidth, buttonHeight, 3);

        editButtonSprite = this.add.container(0, 0)
          .add(editButtonBackground)
          .add(editButtonText)
          .setPosition(0, center ? CENTER_NODE_RADIUS * 0.6 : EXPANDED_NODE_MAIN_RADIUS * 0.8)
          .setVisible(false)
          // .setInteractive(
          //   new Phaser.Geom.Rectangle(
          //     -editButtonText.width / 2,
          //     -editButtonText.height / 2,
          //     editButtonText.width,
          //     editButtonText.height,
          //   ),
          //   Phaser.Geom.Rectangle.Contains
          // )
          .setInteractive((_, x, y, sprite) => editButtonHitTest({ x, y, sprite, buttonWidth, buttonHeight }))
          .setData('nodeData', nodeData)
          .setDepth(2);
        editButtonSprite.on('pointerdown', clickEditButton);
        editButtonSprite.on('pointerover', rolloverEditButton);
        nodeEditButtonSprites[nodeData.id] = editButtonSprite;

        // this.input.enableDebug(editButtonSprite, 0x00ff00);
      }


      const nodeSprite = this.add.container(0, 0)
        .add(nodeImage)
        .add(nodeText)
        .setPosition(position.x, position.y)
        .setScale(scale)
        .setVisible(!isIcon)
        .setInteractive(center ? centerHitTest : nodeHitTest)
        .setData('nodeData', nodeData);

      if (editButtonSprite) nodeSprite.add(editButtonSprite);

      nodeSprite.on('pointerdown', clickNode);
      nodeSprite.on('pointerover', rolloverNode);
      nodeSprite.on('pointerout', rolloffNode);
      nodeSprites[nodeData.id] = nodeSprite;

      // if (center) {
      //   nodeSprite.setInteractive(new Phaser.Geom.Circle(CENTER_NODE_RADIUS, CENTER_NODE_RADIUS, CENTER_NODE_RADIUS), Phaser.Geom.Circle.Contains);
      // } else {
      //   nodeSprite.setInteractive(new Phaser.Geom.Circle(EXPANDED_NODE_RADIUS, EXPANDED_NODE_RADIUS, EXPANDED_NODE_MAIN_RADIUS), Phaser.Geom.Circle.Contains);
      // }
      // this.input.enableDebug(nodeSprite, 0x00ff00);

      if (!center) {
        const iconNodeSprite = this.add.image(0, 0, iconNodeImageName)
          .setPosition(position.x, position.y)
          .setScale(scale)
          .setVisible(isIcon)
          // .setInteractive(iconNodeHitTest)
          // Phaser.Geom.Circle approach works, but iconNodeHitTest doesn't for icons, but
          // reverse is true for non-icon nodes. Perhaps because non-icon nodes use containers
          // (in order to group text with image). In any case, the different approaches seem
          // to work.
          .setInteractive(new Phaser.Geom.Circle(ICON_NODE_RADIUS * 0.9, ICON_NODE_RADIUS * 0.9, ICON_NODE_RADIUS * 0.7), Phaser.Geom.Circle.Contains)
          .setData('nodeData', nodeData);
        // this.input.enableDebug(iconNodeSprite, 0x00ff00);

        iconNodeSprite.on('pointerdown', clickNode);
        iconNodeSprite.on('pointerover', rolloverNode);
        iconNodeSprite.on('pointerout', rolloffNode);
        iconNodeSprites[nodeData.id] = iconNodeSprite;

        if (nodeData.name === selectedNodeName) selectThisNode(nodeData);
      }
    },
  });
}

function update() {
  drawNode({
    nodeData: iWheelExploration,
    selectedNodeName,
    screenWidth: canvas.width,
    screenHalfHeight: canvas.height / 2,
    drawFunction: ({ nodeData, lineSegments }) =>
      lineSegments.map((lineSegment, index) =>
        nodeLines[nodeData.id][index].setTo(lineSegment[0].x, lineSegment[0].y, lineSegment[1].x, lineSegment[1].y)
      ),
  });

  drawNode({
    nodeData: iWheelExploration,
    selectedNodeName,
    screenWidth: canvas.width,
    screenHalfHeight: canvas.height / 2,
    drawFunction: ({ nodeData, position, scale, isIcon }) => {
      const center = isCenter(nodeData);

      if (!center && overlayNode && nodeData.name === overlayNode.name) {
        const radius = isIcon ? ICON_NODE_RADIUS : EXPANDED_NODE_MAIN_RADIUS + 2;
        const screenHeight = canvas.height;
        let x = position.x - OVERLAY_TEXT_WIDTH - radius * scale - 5;
        let arrowDirection = 'left';

        if (x < 0) {
          x = position.x + OVERLAY_ARROW_WIDTH + radius * scale - 4;
          arrowDirection = 'right';
        }

        let y = position.y;
        y = Math.max(overlayText.height / 2, y);
        y = Math.min(screenHeight - overlayText.height / 2, y);

        drawOverlayBackground({ arrowDirection, arrowY: position.y - y });
        overlaySprite.setPosition(x, y);
      }

      const nodeSprite = nodeSprites[nodeData.id];
      nodeSprite.setScale(scale);
      nodeSprite.setDepth(scale);
      nodeSprite.setVisible(!isIcon);
      if (isIcon) {
        nodeSprite.setPosition(-1000, -1000);
      } else {
        nodeSprite.setPosition(position.x, position.y);
      }

      if (!center) {
        const iconNodeSprite = iconNodeSprites[nodeData.id];
        iconNodeSprite.setScale(scale);
        iconNodeSprite.setDepth(scale);
        iconNodeSprite.setVisible(isIcon);
        if (isIcon) {
          iconNodeSprite.setPosition(position.x, position.y);
        } else {
          iconNodeSprite.setPosition(-1000, -1000);
        }
      }
    },
  });
}
